import React from 'react';
import './ProgressBar.css';

const ProgressBar = ({ currentStep, totalSteps }) => {
  return (
    <div className="onboarding-progress-bar">
      <div className="onboarding-progress-segments">
        {Array.from({ length: totalSteps }).map((_, i) => (
          <div key={i} className="onboarding-progress-step">
            <div
              className={`onboarding-progress-segment ${i <= currentStep ? 'active' : ''}`}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProgressBar;
